import { skipToken } from '@reduxjs/toolkit/query';

import { useGetApiProjectsByProjectIdStudioDocumentsQuery } from '@/model/dashboard/api.generated';

export function useStudioAvailability(projectId: string | undefined): boolean {
  const { currentData } = useGetApiProjectsByProjectIdStudioDocumentsQuery(
    projectId ? { projectId } : skipToken,
  );

  return currentData !== undefined;
}
